import type {SmsAction} from 'src/action-creators/sms';
import type {SmsState} from 'src/types/sms';

import {
  RECEIVE_SMS_INFO,
  UPDATE_SMS_INFO,
  UPDATE_NODE_SCHEDULE,
  UPDATE_NOTE_WRITEBACK,
  RESET,
} from 'src/action-creators/sms';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {getMessagingDefaultNoteWritebackState} from 'src/utils/note-writeback';


const initialState = {
  to_number: null,
  from_number: null,
  external_source_id: null,
  category_id: null,
  body: ``,
  sender_category: null,
  surveysAttached: [],
  meetingsAttached: [],
  ...getMessagingDefaultNoteWritebackState(),
  ...getDefaultNodeScheduleState({
    blackout_action: 'SEND_BEFORE',
  }),
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly date_type?: string; readonly date_value?: string; readonly time_type?: string; readonly time_value?: string; readonly offset?: number; readonly date_field?: string | null | undefined; ... 14 more ...; readonly surveysAttached: readonly []; }' is not assignable to type 'SmsState'.
  state: SmsState = initialState,
  action: SmsAction,
): SmsState => {
  switch (action.type) {
    case UPDATE_SMS_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_SMS_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NOTE_WRITEBACK:
      return {
        ...state,
        ...action.payload,
      };
    case RESET:
      // @ts-expect-error - TS2322 - Type '{ date_type?: string; date_value?: string; time_type?: string; time_value?: string; offset?: number; date_field?: string | null | undefined; time_field?: string | null | undefined; dateOffset?: Offset; ... 12 more ...; surveysAttached: readonly []; }' is not assignable to type 'SmsState'.
      return {...initialState};
  }
  return state;
};
